module.exports = __webpack_public_path__ + "static/media/svg-3.8d90c9bf.svg";